import { useState } from 'react';
import { getErrorMessage } from '../api/client';
import { createExpenseSubcategory } from '../api/expenses';
import type { ExpenseCategory } from '../types/expenses';
import { EXPENSE_CATEGORY_LABELS } from '../utils/expenseActions';
import { Modal } from './Modal';

/** Alta rápida de una subcategoría de gasto (Servicios / Honorarios), desde el formulario o el asistente. */
export function ExpenseSubcategoryModal({ category, onClose, onCreated }: { category: ExpenseCategory; onClose: () => void; onCreated: (name: string) => void }) {
  const [name, setName] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string>();

  const save = async () => {
    const trimmed = name.trim();
    if (!trimmed || isSaving) return;
    setIsSaving(true);
    setError(undefined);
    try {
      const result = await createExpenseSubcategory({ category, name: trimmed });
      onCreated(result.subcategory.name);
    } catch (saveError) {
      setError(getErrorMessage(saveError, 'No fue posible registrar la subcategoría.'));
    } finally {
      setIsSaving(false);
    }
  };

  return <Modal
    title={`Agregar ${EXPENSE_CATEGORY_LABELS[category].toLowerCase() === 'servicios' ? 'servicio' : 'concepto'}`}
    isBusy={isSaving}
    onClose={onClose}
    footer={<>
      <button className="button button--ghost" disabled={isSaving} onClick={onClose} type="button">Cancelar</button>
      <button className="button button--primary" disabled={isSaving || !name.trim()} onClick={() => void save()} type="button">{isSaving ? 'Guardando...' : 'Aceptar'}</button>
    </>}
  >
    {error && <div className="alert alert--error">{error}</div>}
    <label className="field"><span>Nombre</span><input autoFocus onChange={(event) => setName(event.target.value)} placeholder="Ej. Mantenimiento de aire acondicionado" value={name} /></label>
  </Modal>;
}
